module.exports = __webpack_public_path__ + "151690a8ee0acc4cd09994ae1a06e606.png";